import { render, staticRenderFns } from "./4mOnePageDetail.vue?vue&type=template&id=88eb8368"
import script from "./4mOnePageDetail.vue?vue&type=script&lang=js"
export * from "./4mOnePageDetail.vue?vue&type=script&lang=js"
import style0 from "./4mOnePageDetail.vue?vue&type=style&index=0&id=88eb8368&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88eb8368')) {
      api.createRecord('88eb8368', component.options)
    } else {
      api.reload('88eb8368', component.options)
    }
    module.hot.accept("./4mOnePageDetail.vue?vue&type=template&id=88eb8368", function () {
      api.rerender('88eb8368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/4mOnePageDetail.vue"
export default component.exports